export default __webpack_public_path__ + "static/media/interval-control-logo-512px.9948c905.png";